import { useSearch } from '@tanstack/react-router';

export const useCalendarDeepLinkParams = (eventIds?: (string | undefined)[]) => {
  const search = useSearch({ strict: false }) as { eventId?: string };
  return {
    deepLinkedEventId: search.eventId,
    isDeepLinkedEvent: !!search.eventId && !!eventIds?.includes(search.eventId),
  };
};
